import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdSlot({ placement, className = "" }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get("/ads", { params: { placement, active_only: true } })
      .then((r) => { if (!cancelled) setAds(r.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [placement]);

  const [tracked, setTracked] = useState(false);
  useEffect(() => {
    if (ads.length === 0 || tracked) return;
    const ad = ads[0];
    api.post(`/ads/${ad.id}/impression`).catch(() => {});
    setTracked(true);
  }, [ads, tracked]);

  if (ads.length === 0) return null;
  const ad = ads[0];

  const track = () => { api.post(`/ads/${ad.id}/click`).catch(() => {}); };

  const Inner = (
    <div className="relative overflow-hidden rounded-lg border border-slate-200 bg-white">
      <div className="absolute top-2 right-2 z-10 text-[9px] font-admin uppercase tracking-widest text-white bg-black/50 px-1.5 py-0.5 rounded">Ad</div>
      <img src={ad.image_url} alt={ad.title} className="w-full h-auto object-cover"/>
    </div>
  );

  return (
    <div className={className} data-testid={`ad-slot-${placement}`}>
      {ad.link_url ? (
        <a href={ad.link_url} target="_blank" rel="noopener sponsored" onClick={track} data-testid={`ad-${ad.id}`}>{Inner}</a>
      ) : Inner}
    </div>
  );
}
